module.exports = __webpack_public_path__ + "2613d1712b0d777a6924e5a2c0b64d7d.svg";